import { ca } from '@cian/analytics';

export function trackBuilderButtonClick({
  realtyUserId,
  builderAllOffersUrl,
  title,
}: {
  realtyUserId: number;
  builderAllOffersUrl: string;
  title: string;
}): void {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'click',
    label: 'specproject_carousel_to_listing',
    page: {
      extra: {
        is_specproject: true,
        hit_url: builderAllOffersUrl,
        carousel_name: title,
        carousel_place: 'below_listing',
      },
    },
    products: [
      {
        id: realtyUserId,
        offerType: 'userid',
      },
    ],
  });
}
